<template>
    <div>
        <DeleteDialog
                title="Löschen"
                text="Benutzer wirklich löschen?"
                :deleteMode="deleteMode"
                :confirmCallback="deleteConfirmCallback" />
        <UserForm v-if="showUserForm" :form-action="userFormAction" :user-id="editUserId" @close="formCloseHandler"/>
        <el-card v-else class="box-card">
            <div slot="header">
                <span>Benutzer</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="handleCreate">Hinzufügen</el-button>
            </div>

            <el-row></el-row>
            <el-row>
                <el-table
                        v-if="!showUserForm"
                        v-loading="loading"
                        :data="users"
                        style="width: 100%">
                    <el-table-column
                            v-for="(col, index) in tableColumns"
                            :key="index"
                            :label="col.label"
                            :prop="col.prop"
                            align="center"
                            :formatter="col.formatter"
                            :width=getColumnWidth(col)>
                    </el-table-column>

                    <el-table-column
                            align="center"
                            fixed="right"
                            width="90px">
                        <template slot-scope="scope">
                            <el-button
                                    @click="handleEdit(scope.row.id)"
                                    type="text"
                                    size="small">Bearbeiten</el-button>
                        </template>
                    </el-table-column>

                    <el-table-column
                            align="center"
                            fixed="right"
                            width="80px">
                        <template slot-scope="scope">
                            <el-button
                                    v-if="get_current_user.id !== scope.row.id"
                                    @click="handleDelete(scope.row.id)"
                                    type="text"
                                    size="small">Löschen</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    /* eslint-disable no-console */

    import { mapGetters } from 'vuex';
    import { DELETE_USER, FETCH_ROLES, FETCH_SUPPLIERS, FETCH_USERS } from '../../../store/types';
    import UserForm from './UserForm';
    import DeleteDialog from '../../atoms/dialog/Delete';

    export default {
        name: 'Users',
        components: { UserForm, DeleteDialog },
        data () {
            return {
                loading: false,
                showUserForm: false,
                editUserId: null,
                deleteMode: false,
            };
        },
        computed: {
            ...mapGetters(['get_supplier', 'get_users', 'get_role_by_id', 'get_current_user']),
            users () {
                return this.get_users;
            },
            tableColumns () {
                return [
                    { prop: 'id', label: 'ID', width: 80 },
                    { prop: 'role', label: 'Rolle', width: 100, formatter: row => this.getRole(row.role_id) },
                    { prop: 'supplier', label: 'Supplier', formatter: row => this.getSupplierName(row.supplier_id) },
                    { prop: 'name', label: 'Name' },
                    { prop: 'email', label: 'Email' },
                ];
            },
        },
        created () {
            this.loading = true;
            this.$store.dispatch(FETCH_SUPPLIERS).then(() => {
                this.$store.dispatch(FETCH_USERS).then(() => {
                    this.$store.dispatch(FETCH_ROLES);
                    this.loading = false;
                });
            });
        },
        methods: {
            getRole (roleId) {
                const role = this.get_role_by_id(roleId);
                if (role) {
                    return role.name;
                }
                return null;
            },
            getSupplierName (supplierId) {
                const supplier = this.get_supplier(supplierId);
                if (supplier) {
                    return supplier.supplier_name;
                }
                return null;
            },
            getColumnWidth (col) {
                return col.width || 'auto';
            },
            handleCreate () {
                this.userFormAction = 'create';
                this.showUserForm = true;
            },
            handleEdit (userId) {
                this.userFormAction = 'edit';
                this.editUserId = userId;
                this.showUserForm = true;
            },
            handleDelete (userId) {
                this.deleteMode = true;
                this.editUserId = userId;
            },
            deleteConfirmCallback () {
                this.deleteMode = false;
                this.loading = true;
                this.$store.dispatch(DELETE_USER, this.editUserId)
                .then((resp) => {
                    this.$message.success(resp.message);
                }).catch((resp) => {
                    this.$message.error(resp.message);
                }).finally(() => {
                    this.editUserId = null;
                    this.loading = false;
                });
            },
            formCloseHandler () {
                this.showUserForm = false;
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/users/Users.vue